import { IVenueApi } from "@greeter/venue-api";
import { SimulatedClock } from "xstate";

export function simulatedFetch<T>(v: T = undefined as any): Promise<T> {
  return new Promise<T>((r) => {
    setTimeout(() => r(v), Math.round(Math.random() * 500 + 250));
  });
}

export function rand(min: number, max: number) {
  return Math.round(Math.random() * (max - min) + min);
}

async function wait(timeoutMs: number) {
  return new Promise((resolve) => setTimeout(resolve, timeoutMs));
}

function mapTypingSteps(value: string) {
  const typedSteps: string[] = [];

  for (let i = 1; i <= value.length; i++) {
    typedSteps.push(value.slice(0, i));
  }

  return typedSteps;
}

export async function simulateTyping(
  send: (partial: string) => void,
  target: string,
  clock?: SimulatedClock
) {
  const typingSteps = mapTypingSteps(target);

  for (const step of typingSteps) {
    send(step);
    const awaitTime = rand(50, 200);
    clock ? clock.increment(awaitTime) : await wait(awaitTime);
  }
}
